var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExercisesWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 3.72016C11.6 3.72016 12.5 2.90938 12.5 1.91843C12.5 0.927478 11.6 0.116699 10.5 0.116699C9.4 0.116699 8.5 0.927478 8.5 1.91843C8.5 2.90938 9.4 3.72016 10.5 3.72016ZM6.8 6.78311L4 19.4853H6.1L7.9 12.2784L10 14.0801V19.4853H12V12.7288L9.9 10.9271L10.5 8.22449C11.8 9.57579 13.8 10.4767 16 10.4767V8.67492C14.1 8.67492 12.5 7.77406 11.7 6.51285L10.7 5.07146C10.3 4.53094 9.7 4.1706 9 4.1706C8.7 4.1706 8.5 4.26068 8.2 4.26068L3 6.24259V10.4767H5V7.41371L6.8 6.78311Z",
    fill: "#FDFDFE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExercisesWhite);
export default __webpack_public_path__ + "static/media/exercises_white.0264c44d2364f6a11177e05d7d37b9f7.svg";
export { ForwardRef as ReactComponent };